import { Typography, Stack, Box, Divider } from "@mui/material"
import { useTheme } from "@mui/material/styles"
import { useTranslation } from "react-i18next"

import conductorTensionDiagram1 from "images/devices/conductorTension/conductor_tension_diagram_1.png"
import conductorTensionDiagram2 from "images/devices/conductorTension/conductor_tension_diagram_2.png"

export default function ConductorTensionDialogContent() {
  const { t } = useTranslation()
  const theme = useTheme()

  return (
    <Stack gap={1} justifyContent="center" padding={1}>
      <Typography>{t("plots_descriptions.CONDUCTOR_TENSION_DIAGRAM.INTRO")}</Typography>
      <Stack flexDirection={{ md: "row" }} gap={2}>
        <Box>
          <Box
            component="img"
            src={conductorTensionDiagram1}
            width="90%"
            sx={{ display: "block", mx: "auto" }}
          />
          <Box>
            <Typography variant="body2" color="text.secondary" sx={{ fontWeight: 500 }}>
              {t("plots_descriptions.CONDUCTOR_TENSION_DIAGRAM.LEGEND")}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {"• " + t("plots_descriptions.CONDUCTOR_TENSION_DIAGRAM.A_DESC")}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {"• " + t("plots_descriptions.CONDUCTOR_TENSION_DIAGRAM.B_DESC")}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {"• " + t("plots_descriptions.CONDUCTOR_TENSION_DIAGRAM.O_DESC")}
            </Typography>
          </Box>
        </Box>
        <Divider
          orientation="vertical"
          flexItem
          sx={{ display: { xs: "none", md: "block" }, mx: "1rem" }}
        />
        <Box>
          <Box
            component="img"
            src={conductorTensionDiagram2}
            width="90%"
            sx={{ display: "block", mx: "auto" }}
          />
          <Typography
            component="p"
            sx={{ color: theme.palette.primary.main, fontWeight: 600 }}
          >
            • {t("plots_descriptions.CONDUCTOR_TENSION_DIAGRAM.T_H_LABEL")}
          </Typography>
          <Typography component="p">
            {t("plots_descriptions.CONDUCTOR_TENSION_DIAGRAM.T_H_DESC")}
          </Typography>
          <br />
          <Typography
            component="p"
            sx={{ color: theme.palette.secondary.main, fontWeight: 600 }}
          >
            • {t("plots_descriptions.CONDUCTOR_TENSION_DIAGRAM.T_AB_LABEL")}
          </Typography>
          <Typography component="p">
            {t("plots_descriptions.CONDUCTOR_TENSION_DIAGRAM.T_AB_DESC")}
          </Typography>
        </Box>
      </Stack>
    </Stack>
  )
}
